<script setup>
import {computed, ref, onMounted, onUnmounted} from 'vue';
import {preloadImage} from '@utils/preloadImage';

const props = defineProps({
    alt: String || '',
    defaultSrc: String,
    imgClass: String || '',
    sources: [Array, Boolean] || null,
});


const computedClass = computed(() => {
   return [
       'object-cover',
       props.imgClass
   ]
});

const defaultSrc = ref(props.defaultSrc);
const sources = ref(props.sources);

const windowWidth = ref(window.innerWidth);

/*
onMounted(async () => {
    window.addEventListener('resize', handleResize);
});

onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
});
*/


</script>

<template>
    <picture>
        <source v-for="(source, index) in sources" :key="index"
                :type="source.type ?? 'image/jpeg'"
                :media="source.media" :srcset="source.srcset" />
        <img :src="defaultSrc" :alt="alt" :class="computedClass" />
    </picture>
</template>

<style scoped>

</style>
